var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3479 23.5305C10.077 23.8187 9.81066 24.0982 9.60826 24.3031L9.09118 23.7861V23.8376C4.84624 19.6762 1.32358 14.0264 1.47337 8.13476L1.47337 8.13466C1.59575 3.28435 6.32583 -0.316535 11.0499 0.660629L11.0501 0.660677C15.1553 1.50778 18.3942 5.45198 18.1359 9.62363L18.1358 9.62392C17.8516 14.2578 14.7649 18.5848 11.6849 22.0767C11.6472 22.1186 11.6221 22.1478 11.6017 22.1716C11.5743 22.2035 11.5555 22.2255 11.526 22.2549L11.5117 22.2693L11.4986 22.2847C11.4985 22.2848 11.4978 22.2857 11.4962 22.2874L11.4887 22.2959L11.4634 22.3243C11.4424 22.3476 11.4144 22.3785 11.3802 22.4161C11.3118 22.4912 11.22 22.5915 11.1126 22.7081C10.8978 22.9414 10.6218 23.2391 10.3479 23.5305Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2749 8.95582C14.2749 11.4199 12.2774 13.4175 9.81324 13.4175C7.34912 13.4175 5.35156 11.4199 5.35156 8.95582C5.35156 6.4917 7.34912 4.49414 9.81324 4.49414C12.2774 4.49414 14.2749 6.4917 14.2749 8.95582Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.6770e5b39cd472262ca9e3bf977bab1a.svg";
export { ForwardRef as ReactComponent };